import _ from 'lodash'
import { CLEAR_GUEST_ADDRESSES } from '../../actions/types'
import brandit_rails from '../../api/brandit_rails'
import {
  clearCheckoutRatesRatesAction,
  clearCheckoutRatesSelectedRateAction
} from '../../redux/storeConfig/slices/slice.checkoutRates'
import { fetchCheckoutSessionToken } from '../../redux/storeConfig/slices/slice.checkoutSessionToken'
import { recalculateTaxIfReady } from '../../redux/storeConfig/slices/slice.checkoutTax'
// CHECKOUT PAGE FUNCTIONS
export const mapDispatchToProps = dispatch => {
  return {
    updateCreditCard: data => dispatch({ type: 'UPDATE_CREDIT_CARD', payload: data }),
    updateAddress: data => dispatch({ type: 'UPDATE_CHECKOUT_ADDRESS', payload: data })
  }
}

export const setCcData = data => async dispatch => dispatch({ type: 'SET_CC_DATA', payload: data })
export const clearShippingQuote = () => async dispatch => dispatch({ type: 'CLEAR_SHIPPING_QUOTE' })
export const setShippingQuote =
  (totalCharges, data = null) =>
  async dispatch =>
    dispatch({ type: 'SET_SHIPPING_QUOTE', payload: { totalCharges, data } })
export const setShippingLoading = bool => async dispatch => dispatch({ type: 'SET_SHIPPING_LOADING', payload: bool })
export const setTaxLoading = bool => async dispatch => dispatch({ type: 'SET_TAX_LOADING', payload: bool })
export const setSubtotalLoading = bool => async dispatch => dispatch({ type: 'SET_SUBTOTAL_LOADING', payload: bool })
export const setErrors = data => async dispatch => dispatch({ type: 'SET_CHECKOUT_ERROR', payload: data })
export const setCustomerAddress =
  (addressObj, isGuestNewAddress = false) =>
  async dispatch => {
    if (isGuestNewAddress) {
      dispatch({ type: 'ADD_GUEST_ADDRESS', payload: addressObj })
    }
    dispatch({ type: 'SET_CUSTOMER_ADDRESS', payload: addressObj })

    // Clear shipping rates when address changes - rates are address-specific
    dispatch(clearCheckoutRatesRatesAction())
    dispatch(clearCheckoutRatesSelectedRateAction())
  }
export const setBillingAddress =
  (addressObj, isGuestNewAddress = false) =>
  async dispatch => {
    if (isGuestNewAddress) {
      dispatch({ type: 'ADD_GUEST_ADDRESS', payload: addressObj })
    }
    dispatch({ type: 'SET_BILLING_ADDRESS', payload: addressObj })
  }
export const clearBillingAddress = () => async dispatch => dispatch({ type: 'CLEAR_BILLING_ADDRESS' })
export const setCreditsUsed = creditsUsedObject => async dispatch =>
  dispatch({ type: 'SET_CREDITS_USED', payload: creditsUsedObject })
export const setPaymentMethod = paymentMethod => async dispatch =>
  dispatch({ type: 'SET_PAYMENT_METHOD', payload: paymentMethod })
export const setAppliedCoupon = code => async dispatch => dispatch({ type: 'SET_APPLIED_COUPON', payload: code })
export const setPoNumber = input => async dispatch => dispatch({ type: 'SET_PO_NUMBER', payload: input })
export const setSubtotals = priceObject => async dispatch => dispatch({ type: 'SET_SUBTOTALS', payload: priceObject })
export const setCheckoutLoading = bool => async dispatch => dispatch({ type: 'SET_CHECKOUT_LOADING', payload: bool })
export const setManagedAddressesLoading = bool => async dispatch =>
  dispatch({ type: 'SET_MANAGED_ADDRESSES_LOADING', payload: bool })
export const setCustomerAddressesLoading = bool => async dispatch =>
  dispatch({ type: 'SET_CUSTOMER_ADDRESSES_LOADING', payload: bool })
export const setCheckoutErrorMessage = message => async dispatch =>
  dispatch({ type: 'SET_CHECKOUT_ERROR_MESSAGE', payload: message })
export const setNet30Confirmed = bool => async dispatch => dispatch({ type: 'SET_NET30_CONFIRMED', payload: bool })
// export const setSetupCharge = price => async dispatch => dispatch({ type: 'SET_SETUP_CHARGE', payload: price })
export const setCustomCheckoutFee = price => async dispatch =>
  dispatch({ type: 'SET_CUSTOM_CHECKOUT_FEE', payload: price })
// Resets Checkout Reducer after order placed
export const checkoutOrderCleanup = location => async dispatch =>
  dispatch({ type: 'CHECKOUT_CLEANUP', payload: location })

// Clears guest addresses from customer_addresses reducer
export const clearGuestAddresses = () => async dispatch => dispatch({ type: CLEAR_GUEST_ADDRESSES })
export const setOrderProcessing = bool => async dispatch => dispatch({ type: 'SET_ORDER_PROCESSING', payload: bool })
export const setMaxQuantityLoading = bool => async dispatch => dispatch({ type: 'MAX_QUANTITY_LOADING', payload: bool })
export const setCustomerNotes = note => async dispatch => dispatch({ type: 'SET_CUSTOMER_NOTES', payload: note })
export const setMultiAddressSelection = (cartItemId, selections) => async dispatch =>
  dispatch({ type: 'SET_MULTI_ADDRESS_SELECTION', payload: { cartItemId, selections } })

export const clearMultiAddressSelection = cartItemId => async dispatch =>
  dispatch({ type: 'CLEAR_MULTI_ADDRESS_SELECTION', payload: cartItemId })
export const setCheckoutFormData = data => async dispatch => dispatch({ type: 'SET_CHECKOUT_FORM_DATA', payload: data })
export const setUseShippingAsBilling = isChecked => ({ type: 'SET_USE_AS_BILLING', payload: isChecked })

/**
 * Restore checkout session data from token response or by fetching
 * @param {string|Object} tokenOrData - Token string (will fetch) or token data object (already fetched)
 */
export const restoreCheckoutSessionFromToken = tokenOrData => async (dispatch, getState) => {
  if (!tokenOrData) return

  try {
    // If passed a string, fetch the token data; otherwise use the passed data directly
    const tokenData =
      typeof tokenOrData === 'string' ? await dispatch(fetchCheckoutSessionToken(tokenOrData)) : tokenOrData

    if (tokenData?.multiAddressSelection?.length > 0) {
      const selectionsByCartItem = {}

      tokenData.multiAddressSelection.forEach(selection => {
        const cartItemId = selection.cartItemId
        if (!selectionsByCartItem[cartItemId]) {
          selectionsByCartItem[cartItemId] = []
        }
        selectionsByCartItem[cartItemId].push({
          address: selection.address,
          quantity: selection.quantity
        })
      })

      // Parse cartItemId to number (Object.entries converts keys to strings)
      Object.entries(selectionsByCartItem).forEach(([cartItemIdStr, selections]) => {
        const cartItemId = parseInt(cartItemIdStr, 10)
        dispatch({ type: 'SET_MULTI_ADDRESS_SELECTION', payload: { cartItemId, selections } })
      })

      // Set selectedCustomerAddress for shipping/tax calculations
      const firstSelection = tokenData.multiAddressSelection[0]
      if (firstSelection?.address) {
        dispatch({ type: 'SET_CUSTOMER_ADDRESS', payload: firstSelection.address })
      }
    }

    // Restore billing address (top-level field, available to all users)
    if (tokenData?.selectedBillingAddress) {
      dispatch({ type: 'SET_BILLING_ADDRESS', payload: tokenData.selectedBillingAddress })
    }

    // Restore useShippingAsBilling (available to all users)
    if (tokenData?.useShippingAsBilling !== undefined) {
      dispatch({ type: 'SET_USE_AS_BILLING', payload: tokenData.useShippingAsBilling })
    }

    // Restore guest-specific checkout data (inner properties remain snake_case as they come from API)
    const guestData = tokenData?.guestCheckoutData
    if (guestData && Object.keys(guestData).length > 0) {
      if (guestData.contact_email) {
        dispatch({ type: 'SET_CONTACT_EMAIL', payload: guestData.contact_email })
        dispatch({ type: 'SET_CHECKOUT_ERROR', payload: { contactEmail: false } })
      }

      if (guestData.guest_addresses?.length > 0) {
        guestData.guest_addresses.forEach(address => {
          dispatch({ type: 'ADD_GUEST_ADDRESS', payload: address })
        })
      }

      if (guestData.selected_customer_address) {
        dispatch({ type: 'SET_CUSTOMER_ADDRESS', payload: guestData.selected_customer_address })
      }
    }

    // Restore shipping address for logged-in single-address checkout
    // If selectedCustomerAddressId exists, restore it (backend is source of truth for what mode was used)
    if (tokenData?.selectedCustomerAddressId) {
      const state = getState()

      const allAddresses = [
        ...(state.customer_addresses ?? []),
        ...Object.values(state.managed_customer_addresses ?? {})
      ]

      const address = allAddresses.find(a => a.id === tokenData.selectedCustomerAddressId)

      if (address) {
        dispatch({ type: 'SET_CUSTOMER_ADDRESS', payload: address })
      } else if (allAddresses.length === 0) {
        // Addresses may not be loaded yet - store the ID to resolve later
        dispatch({ type: 'SET_SESSION_TOKEN_ADDRESS_ID', payload: tokenData.selectedCustomerAddressId })
      }
    }
  } catch (error) {
    console.error('[restoreCheckoutSessionFromToken] Failed to restore:', error)
  }
}

/**
 * Legacy alias for backwards compatibility
 * @param {string} token - The checkout session token
 */
export const restoreMultiAddressSelectionFromToken = token => async dispatch => {
  return dispatch(restoreCheckoutSessionFromToken(token))
}

// Takes priceData object and reduces to final price (before discounts)
export const resolvePrice = (priceData, includeDiscounts = false, isBundle = false) => {
  // optionally use discounted price
  if (
    includeDiscounts === true &&
    ((priceData.discounts && !_.isEmpty(priceData.discounts)) || priceData.adjusted_subtotal >= 0)
  ) {
    return priceData.adjusted_subtotal
  }

  // default final price to item subtotal. change only if there are modifiers
  let result = priceData.subtotal

  if (priceData.tier_price_applied === true) {
    result = priceData.tier_price_subtotal
  }
  if (priceData.sale_price_applied === true) {
    // if there is both a tier price and a sale price, use whichever is lower
    if (priceData.tier_price_applied === true) {
      const specialPriceIsLowerThanTierPrice = priceData.sale_price_subtotal < priceData.tier_price_subtotal
      if (specialPriceIsLowerThanTierPrice) {
        result = priceData.sale_price_subtotal
      }
    } else {
      result = priceData.sale_price_subtotal
    }
  }
  if (priceData.configurable_additional_price_applied === true) {
    result += priceData.configurable_additional_price_subtotal
  }
  if (priceData.template_additional_price_applied === true) {
    result += priceData.template_additional_price_subtotal
  }
  if (priceData.extra_price_cents) {
    result += priceData.extra_price_cents_subtotal
  }

  // If bundle, need setup charge seperately to differentiate prices later
  if (isBundle) {
    return { result, setupCharge: priceData.setup_charge ?? 0 }
  }

  if (priceData.setup_charge) {
    result += priceData.setup_charge
  }
  return result
}

export const fetchCalculatedSubtotal = (cartItems, appliedPromotions) => async dispatch => {
  dispatch(setSubtotalLoading(true))
  await brandit_rails
    .post('/checkout/subtotal', {
      cart_items: cartItems,
      applied_promotions: appliedPromotions,
      subtotal: true
    })
    .then(response => {
      dispatch(setSubtotals(response.data))
      dispatch(recalculateTaxIfReady())
    })
    .finally(() => {
      dispatch(setSubtotalLoading(false))
    })
}

export const resolveUnitPrice = (priceData, considerDiscount = true) => {
  // default final price to item subtotal. change only if there are modifiers
  let result = priceData.unit_price
  const {
    tier_price_applied,
    tier_price_unit_price,
    sale_price_applied,
    sale_price_unit_price,
    configurable_additional_price_applied,
    template_additional_price_applied,
    extra_price_cents,
    adjusted_unit_price,
    template_total_template_additional_unit_price,
    configurable_additional_price_per_unit
  } = priceData

  if (tier_price_applied === true) {
    result = tier_price_unit_price
  }
  if (sale_price_applied === true) {
    result = sale_price_unit_price
  }

  // if a sale price AND tier price are present, use whichever price is lower
  if (tier_price_applied && sale_price_applied) {
    result = tier_price_unit_price < sale_price_unit_price ? tier_price_unit_price : sale_price_unit_price
  }

  // additional prices
  if (configurable_additional_price_applied === true) {
    result += configurable_additional_price_per_unit
  }
  if (template_additional_price_applied === true) {
    result += template_total_template_additional_unit_price
  }
  if (extra_price_cents) {
    result += extra_price_cents
  }

  // if discounts are present, optionally include discounted price
  if (adjusted_unit_price >= 0 && considerDiscount === true) {
    result = adjusted_unit_price
  }
  return result
}

export const calculateGrandTotal = (
  cartItemsSubtotal,
  totalTax = 0,
  totalShipping = 0,
  totalCreditsUsed = 0,
  subtotalReduction = 0
) => {
  return cartItemsSubtotal + totalTax + totalShipping - totalCreditsUsed - subtotalReduction
}

export const fetchGrandTotal =
  (subtotal, taxQuote, shippingDue, creditsUsed, promotions, coupons, cartItems) => async dispatch => {
    // const params = {
    // }
    // params required to calculate grand total:
    // cartItemsSubtotal: state.subtotal,
    // - totalTax: state.taxQuote,
    // totalShipping: shippingDue < 0 ? 0 : shippingDue,
    // creditsUsed: state.creditsUsed,
    // - subtotalDiscount: state.subtotalReduction + state.productReduction,

    await brandit_rails
      .post('/checkout/total', {
        subtotal,
        taxQuote,
        shippingDue,
        creditsUsed,
        promotions,
        coupons,
        cart_items: cartItems
      })
      .then(response => {
        dispatch({ type: 'SET_GRAND_TOTAL', payload: response.data })
      })
  }
